import { render, staticRenderFns } from "./notes-detail-table-panel.vue?vue&type=template&id=2e3517a4&scoped=true&lang=pug"
import script from "./notes-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./notes-detail-table-panel.vue?vue&type=script&lang=js"
import style0 from "./notes-detail-table-panel.vue?vue&type=style&index=0&id=2e3517a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3517a4",
  null
  
)

export default component.exports